import { render, staticRenderFns } from "./ContextSettingsPage.vue?vue&type=template&id=b5de0a0a&scoped=true&"
import script from "./ContextSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./ContextSettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ContextSettingsPage.vue?vue&type=style&index=0&id=b5de0a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5de0a0a",
  null
  
)

export default component.exports